import type { ReactNode } from 'react';
import { PdfIcon } from './DocumentIcons';
import styles from './Documents.module.scss';

export function FileCard({ name, sub, children }: { name: string; sub: string; children?: ReactNode }) {
  return (
    <div className={styles.fileCard}>
      <span className={styles.fileIcon}>
        <PdfIcon />
      </span>
      <span className={styles.fileMeta}>
        <span className={styles.fileName}>{name}</span>
        <span className={styles.fileSub}>{sub}</span>
      </span>
      {children && <span className={styles.fileActions}>{children}</span>}
    </div>
  );
}

export function FileButton({
  onClick,
  disabled,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <button type="button" className={styles.action} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export function FileLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a className={styles.action} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
